// src/components/seo/HomeSEOSection.tsx

export default function HomeSEOSection() {
  return (
    <section className="sr-only">
      <h2>Software de reservas online para negocios</h2>

      <p>
        Bookoll es una plataforma de reservas online diseñada para negocios de
        servicios que necesitan gestionar citas, agenda, clientes y trabajadores
        desde un único sistema.
      </p>

      <p>
        El software permite aceptar reservas online las 24 horas, organizar la
        agenda automáticamente y permitir que los clientes reserven cita desde
        cualquier dispositivo.
      </p>

      <p>
        Cada negocio puede tener su propia página pública con servicios,
        disponibilidad y horarios donde los clientes pueden reservar cita online
        en segundos.
      </p>

      <p>
        Bookoll está pensado para negocios que trabajan con citas o reservas
        como clínicas, peluquerías, entrenadores personales, academias,
        fisioterapeutas o servicios profesionales.
      </p>

      <p>
        La plataforma permite gestionar agenda, clientes, trabajadores,
        servicios y reservas desde un panel centralizado diseñado para mejorar
        la organización y la experiencia de los clientes.
      </p>
    </section>
  );
}
